import {postEventSongAddAdmin, postEventSongAddGuest} from "../../../../helpers/event_helper.js";

// action
import {eventSongAddSuccess, eventSongAddError} from "./reducer";

export const addSongAdmin = (payload) => async (dispatch) => {
  try {
    let response;
    response = postEventSongAddAdmin(
      payload
    );
    const data = await response;

    if (data) {
      dispatch(eventSongAddSuccess(data));
    }
  } catch (error) {
    dispatch(eventSongAddError(error));
  }
};

export const addSongGuest = (payload) => async (dispatch) => {
  try {
    let response;
    response = postEventSongAddGuest(
      payload
    );
    const data = await response;
    if (data) {
      dispatch(eventSongAddSuccess(data));
    }
  } catch (error) {
    dispatch(eventSongAddError(error));
  }
};
